(function () {
  if (window.__hfSliderBlockInit) return;
  window.__hfSliderBlockInit = true;

  var __thisSrc = (document.currentScript && document.currentScript.src) || '';
  var __carouselSrc = __thisSrc ? __thisSrc.replace(/[^\/]+$/, 'hf-carousel.js') : '';

  function findOriginalSlideIdx(list, blockId) {
    var slides = list.querySelectorAll('.hf-carousel__slide');
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].querySelector('[data-shopify-editor-block*="' + blockId + '"]') ||
          (slides[i].getAttribute('data-shopify-editor-block') || '').indexOf(blockId) !== -1) {
        return parseInt(slides[i].dataset.hfLogicalIdx, 10);
      }
    }
    return -1;
  }

  function initRoot(root) {
    if (root.__hfInit) return;
    root.__hfInit = true;

    var blockId = root.dataset.blockId;
    var el = root.querySelector('.hf-slider-carousel');
    if (!el) return;

    var track = el.querySelector('.hf-carousel__track');
    var list = el.querySelector('.hf-carousel__list');
    if (!track || !list) return;

    var bar  = root.querySelector('.hf-slider-block__controls .hf-slider-progress__bar');
    var prev = root.querySelector('.slider-button--prev');
    var next = root.querySelector('.slider-button--next');
    var ctrl = root.querySelector('.hf-slider-block__controls');
    var hl   = root.classList.contains('hf-slider-block--highlight');

    var kids = Array.prototype.filter.call(list.children, function (c) {
      return c.tagName !== 'SCRIPT' && c.tagName !== 'STYLE' && c.tagName !== 'LINK';
    });
    var n = kids.length;
    if (!n) return;

    if (n === 1) root.classList.add('hf-slider-block--single');

    var pvD = parseFloat(root.dataset.perViewDesktop);
    var pvM = parseFloat(root.dataset.perViewMobile);
    var gD  = parseFloat(root.dataset.gapDesktop);
    var gM  = parseFloat(root.dataset.gapMobile);
    var autoplay = root.dataset.autoplay === 'true';
    if (typeof Shopify !== 'undefined' && Shopify.designMode) autoplay = false;
    var autoplaySpeed = parseFloat(root.dataset.autoplaySpeed || '4') * 1000;
    var mq = window.matchMedia('(max-width: 749px)');
    var canLoop = n > 1;

    function curPV()  { return mq.matches ? pvM : pvD; }
    function curGap() { return mq.matches ? gM : gD; }

    function updateBar(idx, total) {
      if (!bar || total < 2) return;
      if (window.hfSliderIndicator) window.hfSliderIndicator(bar, idx, total);
    }

    function checkControls() {
      if (!ctrl) return;
      ctrl.style.display = n <= 1 ? 'none' : '';
    }

    if (el._hfCarousel) { try { el._hfCarousel.destroy(); } catch (e) {} }
    if (el._hfIO) { try { el._hfIO.disconnect(); } catch (e) {} el._hfIO = null; }

    if (hl) {
      kids.forEach(function (c) {
        if (c.classList.contains('hf-hl-wrap')) return;
        var w = document.createElement('div');
        w.className = 'hf-carousel__slide hf-hl-wrap';
        c.parentNode.insertBefore(w, c);
        w.appendChild(c);
      });
    } else {
      kids.forEach(function (c) { c.classList.add('hf-carousel__slide'); });
    }

    function setWidth() {
      var trackW = track.clientWidth;
      if (!trackW) return;
      var pv = curPV(), g = curGap();
      trackW -= g;
      var numGaps = Math.ceil((pv - 1) / 2);
      var sw = Math.max(0, (trackW - 2 * numGaps * g) / pv);
      root.style.setProperty('--hf-sb-slide-w', sw + 'px');
      list.style.gap = g + 'px';
      Array.prototype.forEach.call(list.children, function (s) {
        if (s.classList && s.classList.contains('hf-carousel__slide')) {
          s.style.flex = '0 0 ' + sw + 'px';
          s.style.width = sw + 'px';
        }
      });
    }

    setWidth();

    var initialIdx = 0;
    if (typeof Shopify !== 'undefined' && Shopify.designMode && window.__hfSliderSelected) {
      var bidInit = window.__hfSliderSelected[blockId];
      if (bidInit) {
        var foundIdx = findOriginalSlideIdx(list, bidInit);
        if (foundIdx >= 0) initialIdx = foundIdx;
      }
    }

    var carousel = window.HfCarousel(track, {
      loop: canLoop,
      align: 'center',
      duration: 400,
      watchDrag: canLoop,
      startIndex: initialIdx,
      perView: Math.max(pvD, pvM),
      autoplay: autoplay && canLoop ? {
        delay: autoplaySpeed,
        stopOnInteraction: true,
        stopOnMouseEnter: false,
      } : null,
    });
    el._hfCarousel = carousel;
    root.__hfBlockId = blockId;

    function applyHighlight() {
      if (!hl) return;
      var activeLogical = carousel.selectedScrollSnap();
      var slidesAll = list.querySelectorAll('.hf-carousel__slide');
      slidesAll.forEach(function (s) {
        var lIdx = parseInt(s.dataset.hfLogicalIdx, 10);
        if (lIdx === activeLogical) s.classList.add('hf-hl-active');
        else s.classList.remove('hf-hl-active');
      });
    }

    function ready() {
      var idx = carousel.selectedScrollSnap();
      updateBar(idx, n);
      applyHighlight();
      checkControls();
      root.classList.add('hf-slider-ready');
    }

    carousel.on('init', ready);
    carousel.on('select', function () {
      var idx = carousel.selectedScrollSnap();
      updateBar(idx, n);
      applyHighlight();
    });
    carousel.on('settle', function () {
      applyHighlight();
    });
    carousel.on('resize', function () {
      setWidth();
      try { carousel.reInit(); } catch (e) {}
      checkControls();
    });

    ready();

    requestAnimationFrame(function () {
      setWidth();
      try { carousel.reInit(); } catch (e) {}
      ready();
    });

    mq.addEventListener('change', function () {
      setWidth();
      try { carousel.reInit(); } catch (e) {}
    });

    el._hfRefresh = function () {
      setWidth();
      try { carousel.reInit(); } catch (e) {}
    };

    if (typeof ResizeObserver !== 'undefined') {
      var lastW = track.clientWidth;
      var ro = new ResizeObserver(function () {
        var w = track.clientWidth;
        if (w !== lastW && w > 0) {
          lastW = w;
          setWidth();
          try { carousel.reInit(); } catch (e) {}
          checkControls();
        }
      });
      ro.observe(track);
      el._hfRO = ro;
    }

    if (prev) prev.addEventListener('click', function (e) { carousel.scrollPrev(); if (e.detail > 0) prev.blur(); });
    if (next) next.addEventListener('click', function (e) { carousel.scrollNext(); if (e.detail > 0) next.blur(); });

    if (autoplay && canLoop && 'IntersectionObserver' in window) {
      var ap = carousel.plugins().autoplay;
      if (ap) {
        var io = new IntersectionObserver(function (entries) {
          if (!entries[0]) return;
          if (entries[0].isIntersecting) ap.play(); else ap.stop();
        }, { threshold: 0.15 });
        io.observe(root);
        el._hfIO = io;
      }
    }
  }

  function loadCarouselThen(cb) {
    if (window.HfCarousel) return cb();
    var existing = document.querySelector('script[data-hf-carousel-loader]');
    if (existing) {
      existing.addEventListener('load', cb, { once: true });
      return;
    }
    if (!__carouselSrc) return;
    var s = document.createElement('script');
    s.src = __carouselSrc;
    s.dataset.hfCarouselLoader = 'true';
    s.async = false;
    s.onload = cb;
    document.head.appendChild(s);
  }

  function whenVisible(el, cb) {
    if (!('IntersectionObserver' in window)) { cb(); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) {
        io.disconnect();
        cb();
      }
    }, { rootMargin: '200px' });
    io.observe(el);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.hf-slider-block[data-block-id]').forEach(function (root) {
      whenVisible(root, function () {
        loadCarouselThen(function () { initRoot(root); });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('hf:megamenu:content-loaded', function (event) {
    var scope = event && event.detail && event.detail.scope;
    if (scope && scope.querySelectorAll) initAll(scope);
  });

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    window.__hfSliderSelected = window.__hfSliderSelected || {};

    document.addEventListener('shopify:block:select', function (evt) {
      var root = evt.target.closest('.hf-slider-block[data-block-id]');
      if (!root) return;
      var blockId = root.dataset.blockId;
      window.__hfSliderSelected[blockId] = evt.detail.blockId;
      var sp = root.querySelector('.hf-slider-carousel');
      if (!sp || !sp._hfCarousel) return;
      var sliderList = sp.querySelector('.hf-carousel__list');
      var idx = findOriginalSlideIdx(sliderList, evt.detail.blockId);
      if (idx >= 0) sp._hfCarousel.scrollTo(idx);
    });

    document.addEventListener('shopify:block:deselect', function (evt) {
      var root = evt.target.closest('.hf-slider-block[data-block-id]');
      if (!root) return;
      delete window.__hfSliderSelected[root.dataset.blockId];
    });
  }
})();
